// A page's image block is the source for both cards and its public page.
// Absence/error is not permission to invent an unrelated fallback image.
export function contentSections(content = {}) {
  let sections = content.sections;
  for (let i = 0; i < 2 && typeof sections === 'string'; i++) {
    try { sections = JSON.parse(sections); } catch { return []; }
  }
  return Array.isArray(sections) ? sections : [];
}
export function imageVisible(data = {}, placement = 'page') {
  if (data.hidden === true || data.visible === false || data.showImage === false || data.hideImage === true) return false;
  return placement === 'card' ? data.showOnCard !== false : data.showOnPage !== false && data.hideOnPage !== true;
}
export function safeImageUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return null;
  const s = value.trim();
  if (/^\/(?!\/)/.test(s) && !s.includes('\\')) return s;
  try { const u = new URL(s); return ['https:', 'http:'].includes(u.protocol) && !u.username && !u.password ? u.href : null; } catch { return null; }
}
export function cmsMedia(content = {}, placement = 'page') {
  const block = contentSections(content).find(s => s?.type === 'image' && safeImageUrl((s.data || s).imageUrl));
  if (block) {
    const data = block.data || block;
    if (!imageVisible(data, placement)) return null;
    return {src:safeImageUrl(data.imageUrl),alt:data.altText ?? content.title ?? '',caption:data.caption || '',fit:data.objectFit === 'contain' ? 'contain' : 'cover'};
  }
  if (!imageVisible(content, placement)) return null;
  const src = safeImageUrl(content.imageUrl || content.image || content.ogImage);
  return src ? {src,alt:content.altText ?? content.title ?? '',caption:'',fit:'cover'} : null;
}
